import PropTypes from 'prop-types';
import styles from './index.module.less';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';

const FJModal = props => {
    let {
        visible,
        maskStyle,
        zIndex,
        width,
        backgroundColor,
        onCancel,
        duration,
        onDragEnter = () => {},
        onShow,
        onShown,
        onHide,
        onHidden,
        children,
        borderRadius,
        boxShadow,
    } = props;
    let _showTimer = null;
    let _hideTimer = null;
    const modalRef = useRef(null);
    useEffect(() => {
        toggleContainer(!visible);
        document.body.addEventListener('keydown', _keyboardEventFunc);
        return () => {
            document.body.removeEventListener('keydown', _keyboardEventFunc);
        };
    }, []);
    useEffect(() => {
        toggleContainer();
        window.hasModal = visible;
    }, [visible]);
    const _clearTimer = () => {
        if (_showTimer) {
            clearTimeout(_showTimer);
        }
        if (_hideTimer) {
            clearTimeout(_hideTimer);
        }
    };
    const _keyboardEventFunc = e => {
        switch (e.keyCode) {
            case 27:
                onCancel && onCancel();
                break;
            default:
        }
    };
    const toggleContainer = flush => {
        _clearTimer();
        if (visible) {
            if (onShow) {
                onShow();
            }
            modalRef.current.style.display = 'block';
            _showTimer = setTimeout(() => {
                if (onShown) {
                    onShown();
                }
            }, duration);
        } else {
            if (flush) {
                modalRef.current.style.display = 'none';
            } else {
                if (onHide) {
                    onHide();
                }
                _hideTimer = setTimeout(() => {
                    if (modalRef.current) modalRef.current.style.display = 'none';
                    if (onHidden) {
                        onHidden();
                    }
                }, duration);
            }
        }
    };
    const contentHandleClick = e => {
        e.stopPropagation();
    };
    let maskCls = classNames(styles.remodal_mask, visible ? styles.remodal_fade_in : styles.remodal_fade_out);

    let containerCls = classNames(
        styles.remodal_container,
        visible ? styles.remodal_zoom_modal_in : styles.remodal_zoom_modal_out,
    );
    return (
        <div
            className={styles.remodal_root}
            ref={modalRef}
            style={{
                zIndex,
            }}
            onDragEnter={onDragEnter}
        >
            <div
                className={maskCls}
                style={{
                    ...maskStyle,
                    animationDuration: duration + 'ms',
                }}
            />
            <div
                className={containerCls}
                style={{
                    animationDuration: duration + 'ms',
                }}
                onClick={onCancel}
            >
                <div
                    className={styles.remodal_content}
                    onClick={contentHandleClick}
                    style={{
                        width,
                        backgroundColor,
                        borderRadius,
                        boxShadow,
                    }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};
FJModal.propTypes = {
    visible: PropTypes.bool,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    onShown: PropTypes.func,
    onHidden: PropTypes.func,
    onCancel: PropTypes.func,
    keyboard: PropTypes.bool,
    mask: PropTypes.bool,
    maskClosable: PropTypes.bool,
    maskStyle: PropTypes.object,
    zIndex: PropTypes.number,
    backgroundColor: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    duration: PropTypes.number,
    children: PropTypes.node,
    onDragEnter: PropTypes.func,
    borderRadius: PropTypes.number,
    boxShadow: PropTypes.string,
};

export default FJModal;
